<template>
  <BaseModal overlay-class="other_modals net_prob">
    <div class="content">
      <BaseImage src="/static/images/other/device_icon.svg" alt="Different Devices Icon" />

      <h3 class="title">{{ $_translations.value.modal_form_email_title }}</h3>

      <BaseTextFormInput
        :model-value="formValues.email.state"
        :label="$_translations.value.modal_form_email_input_label_email"
        :error="formValues.email.validation.error"
        :error-message="$_translations.value[formValues.email.validation.message]"
        @update:modelValue="formValues.email.setState"
      />

      <BaseButton
        container-class="update_info"
        :disabled="submitting"
        @click:button.prevent="handleSubmit"
      >
        {{ $_translations.value.modal_form_email_button_proceed }}
      </BaseButton>

    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseTextFormInput from '@/components/formInput/BaseTextFormInput.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import useAuthStore from '@/store/modules/auth.js';
import useFormHook from '@/hooks/useForm.js';
import useUILockHook from '@/hooks/useUILock.js';
import { emailValidationConfiguration } from '@/constants/validation.js';

const emits = defineEmits(['submit:success']);

const authStore = useAuthStore();

const { formValues, isFormInvalid, resetFormErrors } = useFormHook({ email: '' });
const [submitting, setSubmittingState] = useUILockHook();

const validateForm = () => {
  if (!formValues.email.state) {
    formValues.email.setValidation({ error: true, message: 'common_error_input_field_required' });
  } else if (!formValues.email.state.match(emailValidationConfiguration.formatRegex)) {
    formValues.email.setValidation({ error: true, message: 'common_error_email_format_restriction' });
  }

  return isFormInvalid();
};

const handleSubmit = async () => {
  try {
    setSubmittingState(true);

    resetFormErrors();

    const invalid = validateForm();

    if (invalid) { return; }

    await authStore.dispatchChangeEmail({ email: formValues.email.state });

    emits('submit:success');
  } catch {
    formValues.email.setValidation({ error: true, message: 'common_error_server_unavailable' });
  } finally {
    setSubmittingState(false);
  }
};
</script>
